import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useRequestsBankOpsFilterFields } from './hooks/useRequestsBankOpsFilterFields';

export const RequestsBankOpsListFilterChips: React.FC = () => {
  const fields = useRequestsBankOpsFilterFields();

  return <FilterChips fields={fields} />;
};
